/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-plusplus */
import React, { useEffect, useState } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import { useQuery } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import ActionLinks from "../../../Common/components/EndPage/ActionLinks/ActionLinks";
import ActionSharing from "../../../Common/components/EndPage/ActionSharing/ActionSharing";
import ConfigurationSaved from "../../../Common/components/EndPage/ConfigurationSaved/ConfigurationSaved";
import Documentation from "../../../Common/components/EndPage/Documentation/Documentation";
import ProductDataSheetLink from "../../../Common/components/Shared/ProductDataSheetLink";
import Navigator from "../../../Common/layouts/Navigator/Navigator";
import { selectLocale, setFullScreen, updateConfiguration } from "../../../Common/store/slices/common";
import { getProductImgUrl, getProductsDescriptions } from "../../../Common/utils/api/api";
import t from "../../../Common/utils/translation/translator";
import Seperator from "../../components/Seperator/Seperator";
import {
  axisSupportToDisplayString,
  getAdaptationKitToBundleQty,
  getAdaptationKitWithinBundleQty,
  getAxisQty,
  getDriveQuantity,
  orientationToDisplayString
} from "../../store/data/cartesianData";
import {
  resetCartesian,
  selectAdaptationKitToBundleQty,
  selectAdaptationKitWithinBundleQty,
  selectAxisOptions,
  selectAxisQty,
  selectAxisSelection,
  selectBillOfMaterials,
  selectCartesianConfiguration,
  selectCartesianSteps,
  selectDriveQuantity,
  selectDynamics,
  selectMechanics,
  setCartesianCurrentStep
} from "../../store/slices/cartesian";
import "./FinalizeCartesian.scss";

const accessoriesDatas = [
  {
    code: "GBK0600702F",
    description: "Kit réducteur pour moteur diamètre 60mm",
    quantity: 1
  },
  {
    code: "VW3A3608",
    description: "Carte de communication CANopen 2xRJ45",
    quantity: 1
  }
];

const MechanicsSummarySection = ({ ...props }) => {
  const mechanics = useSelector(selectMechanics);
  const axisSelection = useSelector(selectAxisSelection);
  const dynamics = useSelector(selectDynamics);
  let axisQty = useSelector(selectAxisQty);
  if (axisQty === undefined) {
    const bom = useSelector(selectBillOfMaterials);
    axisQty = getAxisQty(bom);
  }

  const Input_Peak_velocity = [...dynamics.steps?.map((step) => step?.peak)];
  const selectedAxis = axisSelection.selectedAxis;
  return (
    <>
      <div className="flex">
        <div className=" w-[75%] MechanicsSummarySection grid-wrapper mb-4" {...props}>
          <div className="flex flex-col">
            <div className="finalizecartesian-undeline">{t("cartesian.ui.axis_selection.axis_length")}</div>
            <div className="flex text-xxs space-x-1">
              <div className="finalizecartesian-values">{axisSelection.selectedAxis?.calculations?.axisLength} mm</div>
            </div>
          </div>

          <div className="flex flex-col">
            <div className="finalizecartesian-undeline">{t("cartesian.ui.mechanics.axis_orientation")}</div>
            <div className="flex text-xxs space-x-1">
              <div className="finalizecartesian-values">
                {mechanics.carriageOrientation === ""
                  ? "--"
                  : orientationToDisplayString(mechanics.carriageOrientation)}
              </div>
            </div>
          </div>

          <div className="flex flex-col">
            <div className="finalizecartesian-undeline">{t("cartesian.ui.mechanics.axis_angle")}</div>
            <div className="flex text-xxs space-x-1">
              <div className="finalizecartesian-values">
                {mechanics.axisAngle === "" ? "--" : mechanics.axisAngle} °
              </div>
            </div>
          </div>

          <div className="flex flex-col">
            <div className="finalizecartesian-undeline">{t("cartesian.ui.mechanics.axis_support")}</div>
            <div className="flex text-xxs space-x-1">
              <div className="finalizecartesian-values">
                {mechanics.axisSupport === "" ? "--" : axisSupportToDisplayString(mechanics.axisSupport)}
              </div>
            </div>
          </div>

          <div className="flex flex-col">
            <div className="finalizecartesian-undeline">{t("cartesian.ui.mechanics.quantity_of_carriages")}</div>
            <div className="flex text-xxs space-x-1">
              <div className="finalizecartesian-values">
                {mechanics.quantityCarriages === "" ? "-- pcs" : mechanics.quantityCarriages}
              </div>
            </div>
          </div>

          <div className="flex flex-col">
            <div className="finalizecartesian-undeline">{t("cartesian.ui.axis_selection.speed")}</div>
            <div className="flex text-xxs space-x-1">
              <div className="finalizecartesian-values">
                {Math.max(...Input_Peak_velocity) === null ? "--" : Math.max(...Input_Peak_velocity)?.toFixed(2)} m/s
              </div>
            </div>
          </div>
        </div>
        <div className="w-[25%] flex justify-around">
          <div className="flex h-[100px] w-[100px]">
            <img src={getProductImgUrl(selectedAxis?.axis?.axisGCR)} alt="Axis" />
          </div>
          <div className="flex flex-col ml-3">
            <div className="finalizecartesian-undeline">{t("cartesian.ui.finalize.quantity")}</div>
            <div className="flex text-xxs space-x-1 justify-around">
              <div className="finalizecartesian-values">{axisQty}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const GearBoxSection = ({ ...props }) => {
  const axisOptions = useSelector(selectAxisOptions);
  const gearboxMounted = axisOptions?.mountingOptions?.gearbox?.mounted;

  const gearbox = axisOptions?.selectedBundle?.bundleData?.gearbox;

  const axisSelection = useSelector(selectAxisSelection);
  const selectedAxis = axisSelection.selectedAxis;
  return (
    gearbox && (
      <div className="flex">
        <div className="w-[75%] GearBoxSection mt-4" {...props}>
          <div className="text-[#626469] mb-2 font-semibold">
            {gearboxMounted
              ? t("cartesian.ui.finalize.gearbox_mounted_to_this_axis")
              : t("cartesian.ui.finalize.gearbox_not_mounted_to_this_axis")}
          </div>
          <div className="grid-wrapper-2-col-1-row mb-4">
            <div className="flex flex-col">
              <div className="finalizecartesian-undeline">{t("cartesian.ui.finalize.product_code")}</div>
              <div className="flex text-xxs space-x-1">
                <div className="finalizecartesian-values-blue underline">
                  <ProductDataSheetLink
                    reference={gearbox?.commercialReference}
                    data-testid="product-data-sheet-link-gearbox"
                  />
                </div>
              </div>
            </div>

            <div className="flex flex-col">
              <div className="finalizecartesian-undeline">{t("cartesian.ui.finalize.type_of_planetary_gearbox")}</div>
              <div className="flex text-xxs space-x-1">
                <div className="finalizecartesian-values">{gearbox?.productOrComponentType}</div>
              </div>
            </div>
          </div>
        </div>
        <div className="w-[25%] flex justify-around">
          <div className="flex h-[100px] w-[100px]">
            <img src={getProductImgUrl(gearbox?.commercialReference)} alt="Axis" />
          </div>

          <div className="flex flex-col mt-11 ml-3">
            <div className="finalizecartesian-undeline">{t("cartesian.ui.finalize.quantity")}</div>
            <div className="flex text-xxs space-x-1 justify-around">
              <div className="finalizecartesian-values">
                {
                  // if selectedAxis?.axis?.axisModel contains "PAD" then show 2 else 1
                  selectedAxis?.axis?.axisModel?.includes("PAD42E") ? 2 : 1
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

const MotorSection = ({ ...props }) => {
  const axisOptions = useSelector(selectAxisOptions);
  const motorMounted = axisOptions?.mountingOptions?.motor?.mounted;

  const motor = axisOptions?.selectedBundle?.bundleData?.motor;

  const axisSelection = useSelector(selectAxisSelection);
  const selectedAxis = axisSelection.selectedAxis;
  return (
    motor && (
      <div className="flex">
        <div className="w-[75%] MotorSection mt-4" {...props}>
          <div className="text-[#626469] mb-2 font-semibold">
            {motorMounted
              ? t("cartesian.ui.finalize.motor_mounted_to_this_axis")
              : t("cartesian.ui.finalize.motor_not_mounted_to_this_axis")}
          </div>
          <div className="grid-wrapper-1-col-1-row mb-4">
            <div className="flex flex-col">
              <div className="finalizecartesian-undeline">{t("cartesian.ui.finalize.product_code")}</div>
              <div className="flex text-xxs space-x-1">
                <div className="finalizecartesian-values-blue underline">
                  <ProductDataSheetLink
                    reference={motor?.commercialReference}
                    data-testid="product-data-sheet-link-motor"
                  />
                </div>
              </div>
            </div>

            <div className="flex flex-col">
              <div className="finalizecartesian-undeline">{t("cartesian.ui.finalize.motor_type")}</div>
              <div className="flex text-xxs space-x-1">
                <div className="finalizecartesian-values">{motor?.type}</div>
              </div>
            </div>

            <div className="flex flex-col">
              <div className="finalizecartesian-undeline">{t("cartesian.ui.finalize.motor_flange_size")}</div>
              <div className="flex text-xxs space-x-1">
                <div className="finalizecartesian-values">{motor?.flangeSize} mm</div>
              </div>
            </div>

            <div className="flex flex-col">
              <div className="finalizecartesian-undeline">{t("cartesian.ui.finalize.electrical_connection_name")}</div>
              <div className="flex text-xxs space-x-1">
                <div className="finalizecartesian-values">{motor?.connector}</div>
              </div>
            </div>
          </div>
        </div>
        <div className="w-[25%] flex justify-around">
          <div className="flex h-[100px] w-[100px] mt-9">
            <img src={getProductImgUrl(motor?.commercialReference)} alt="Axis" />
          </div>

          <div className="flex flex-col mt-12 justify-center">
            <div className="finalizecartesian-undeline">{t("cartesian.ui.finalize.quantity")}</div>
            <div className="flex text-xxs space-x-1 justify-center">
              <div className="finalizecartesian-values flex ">
                {
                  // if selectedAxis?.axis?.axisModel contains "PAD" then show 2 else 1
                  selectedAxis?.axis?.axisModel?.includes("PAD42E") ? 2 : 1
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

const LinearAxis = ({ ...props }) => {
  const configuration = useSelector(selectCartesianConfiguration);
  const [isLinearAxisCollapse, setLinearAxisCollapse] = useState(false);
  const axisSelection = useSelector(selectAxisSelection);

  return (
    <>
      <div
        onClick={() => setLinearAxisCollapse(!isLinearAxisCollapse)}
        className="LinearAxis bg-[#A0A4A8] rounded-sm text-white h-7 px-2 font-semibold flex items-center space-x-2 cursor-pointer select-none"
        {...props}
      >
        {!isLinearAxisCollapse && <FiChevronDown />}
        {isLinearAxisCollapse && <FiChevronUp />}
        {/* <span>Linear Axis PAS42BBM1000A2BAxxxR/21G0H70_GBX060003K_BMH0702T06A1A</span> */}
        <span>
          {t("cartesian.ui.finalize.linear_axis")} {configuration.configData.productCode}
        </span>
      </div>
      {!isLinearAxisCollapse && (
        <div className="flex text-sm">
          <div className="flex-1 flex-col">
            <div className="text-secondary underline mb-1 font-semibold text-sm cursor-pointer">
              {configuration.configData.productCode}
            </div>
            <MechanicsSummarySection data-testid="mechanics-summary-section" />
            <Seperator data-testid="separator-1" />
            <GearBoxSection data-testid="gearbox-section" />
            <Seperator data-testid="separator-2" />
            <MotorSection data-testid="motor-section" />
          </div>
        </div>
      )}
    </>
  );
};

const DriveHeaderSection = ({ ...props }) => (
  <div className="DriveHeaderSection flex flex-row p-[0.25rem] bg-[#00000010] border-[0.5px]" {...props}>
    <div className="finalizecartesian-summary w-[25%]">{t("cartesian.ui.finalize.product_code")}</div>
    <div className="finalizecartesian-summary w-[65%]">{t("cartesian.ui.finalize.description")}</div>
    <div className="finalizecartesian-summary w-[10%] flex justify-center">{t("cartesian.ui.finalize.quantity")}</div>
  </div>
);

const DriveDatasSection = ({ ...props }) => {
  const axisOptions = useSelector(selectAxisOptions);
  let driveQuantity = useSelector(selectDriveQuantity);
  if (driveQuantity === undefined) {
    const bom = useSelector(selectBillOfMaterials);
    driveQuantity = getDriveQuantity(bom);
  }

  const drive = axisOptions?.selectedBundle?.bundleData?.drive;
  const [description, setDescription] = useState("");
  const locale = useSelector(selectLocale);

  const {
    refetch: execGetDriveDescription
    // isFetching: isFetchingGetProductsDescriptions,
    // isLoading: isLoadingGetProductsDescriptions
  } = useQuery(
    "GET PRODUCTS DESCRIPTIONS : it's a Post method",
    async () => {
      try {
        const fetchedDescriptions = await getProductsDescriptions([drive?.commercialReference]);
        setDescription(
          fetchedDescriptions?.[0]?.catalogue_product?.long_dec?.translation?.[locale] ||
            fetchedDescriptions?.[0]?.catalogue_product?.long_desc?.translation?.["en-GB"]
        );
        return fetchedDescriptions;
      } catch (error) {
        console.error("ERR", error);
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  useEffect(() => {
    if (drive) {
      execGetDriveDescription();
    }
  }, [drive]);

  const axisSelection = useSelector(selectAxisSelection);
  const selectedAxis = axisSelection.selectedAxis;

  const content = [];
  if (drive) {
    content.push(
      <div className="DriveDatasSection flex flex-row mb-2 p-[0.25rem]" {...props}>
        <div className="finalizecartesian-values-blue underline w-[25%]">
          <ProductDataSheetLink
            reference={drive?.commercialReference}
            data-testid="product-data-sheet-link-drive-data"
          />
        </div>
        <div className="finalizecartesian-summary w-[65%]">{description}</div>
        <div className="finalizecartesian-summary w-[10%] flex justify-center">{driveQuantity}</div>
      </div>
    );
  }
  return content;
};

const DriveSection = ({ ...props }) => {
  const [isDriveCollapse, setDriveCollapse] = useState(false);
  const axisOptions = useSelector(selectAxisOptions);
  const drive = axisOptions?.selectedBundle?.bundleData?.drive;
  const driveAddedToBOM = axisOptions?.mountingOptions?.drive?.addedToBOM;
  return (
    drive &&
    driveAddedToBOM && (
      <div className="DriveSection" {...props}>
        <div
          onClick={() => setDriveCollapse(!isDriveCollapse)}
          className="bg-[#A0A4A8] rounded-sm text-white h-7 px-2 font-semibold flex items-center space-x-2 cursor-pointer select-none"
        >
          {!isDriveCollapse && <FiChevronDown />}
          {isDriveCollapse && <FiChevronUp />}
          <span>Drive</span>
        </div>

        {!isDriveCollapse && (
          <div className="flex flex-col">
            <DriveHeaderSection data-testid="drive-header-section" />
            <DriveDatasSection data-testid="drive-data-section" />
          </div>
        )}
      </div>
    )
  );
};

// Gearbox section
const GearboxHeaderSection = ({ ...props }) => (
  <div className="GearboxHeaderSection flex flex-row p-[0.25rem] bg-[#00000010] border-[0.5px]" {...props}>
    <div className="finalizecartesian-summary w-[25%]">Product Code</div>
    <div className="finalizecartesian-summary w-[65%]">Description</div>
    <div className="finalizecartesian-summary w-[10%]">Quantity</div>
  </div>
);

const GearboxDatasSection = ({ ...props }) => {
  const axisOptions = useSelector(selectAxisOptions);
  const gearbox = axisOptions?.selectedBundle?.bundleData?.gearbox;
  const [description, setDescription] = useState("");
  const locale = useSelector(selectLocale);

  const {
    refetch: execGetGearboxDescription
    // isFetching: isFetchingGetProductsDescriptions,
    // isLoading: isLoadingGetProductsDescriptions
  } = useQuery(
    "GET PRODUCTS DESCRIPTIONS : it's a Post method",
    async () => {
      try {
        const fetchedDescriptions = await getProductsDescriptions([gearbox?.commercialReference]);
        setDescription(
          fetchedDescriptions?.[0]?.catalogue_product?.long_dec?.translation?.[locale] ||
            fetchedDescriptions?.[0]?.catalogue_product?.long_desc?.translation?.["en-GB"]
        );
        return fetchedDescriptions;
      } catch (error) {
        console.error("ERR", error);
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  useEffect(() => {
    if (gearbox) {
      execGetGearboxDescription();
    }
  }, [gearbox]);

  const content = [];
  if (gearbox) {
    content.push(
      <div className="GearboxDatasSection flex flex-row mb-2 p-[0.25rem]" {...props}>
        <div className="finalizecartesian-values-blue underline w-[25%]">
          <ProductDataSheetLink
            reference={gearbox?.commercialReference}
            data-testid="product-data-sheet-link-gearbox"
          />
        </div>
        <div className="finalizecartesian-summary w-[65%]">{description}</div>
        <div className="finalizecartesian-summary w-[10%]">1</div>
      </div>
    );
  }
  return content;
};

const GearboxSection = ({ ...props }) => {
  const [isGearboxCollapse, setGearboxCollapse] = useState(false);
  const axisOptions = useSelector(selectAxisOptions);
  const gearbox = axisOptions?.selectedBundle?.bundleData?.gearbox;
  const gearboxMounted = axisOptions?.mountingOptions?.gearbox?.mounted;
  return (
    gearbox &&
    gearboxMounted && (
      <div className="GearboxSection" {...props}>
        <div
          onClick={() => setGearboxCollapse(!isGearboxCollapse)}
          className="bg-[#A0A4A8] rounded-sm text-white h-7 px-2 font-semibold flex items-center space-x-2 cursor-pointer select-none"
        >
          {!isGearboxCollapse && <FiChevronDown />}
          {isGearboxCollapse && <FiChevronUp />}
          <span>Gearbox</span>
        </div>

        {!isGearboxCollapse && (
          <div className="flex flex-col">
            <GearboxHeaderSection data-testid="gearbox-header-section" />
            <GearboxDatasSection data-testid="gearboc-data-section" />
          </div>
        )}
      </div>
    )
  );
};

const AccessoriesHeaderSection = ({ ...props }) => (
  <div className="AccessoriesHeaderSection flex flex-row p-[0.25rem] bg-[#00000010] border-[0.5px]" {...props}>
    <div className="finalizecartesian-summary w-[25%]">{t("cartesian.ui.finalize.product_code")}</div>
    <div className="finalizecartesian-summary w-[65%]">{t("cartesian.ui.finalize.description")}</div>
    <div className="finalizecartesian-summary w-[10%] flex justify-center">{t("cartesian.ui.finalize.quantity")}</div>
  </div>
);

const AccessoriesDatasSection = ({ ...props }) => {
  const content = [];
  for (let i = 0; i < accessoriesDatas.length; i++) {
    const accessoriesData = accessoriesDatas[i];
    content.push(
      <div className="AccessoriesDatasSection flex flex-row p-[0.25rem]" {...props}>
        <div className="finalizecartesian-values-blue underline w-[25%]">{accessoriesData.code}</div>
        <div className="finalizecartesian-summary w-[65%]">{accessoriesData.description}</div>
        <div className="finalizecartesian-summary w-[10%]">{accessoriesData.quantity}</div>
      </div>
    );
  }
  return content;
};

const AccessoriesSection = ({ ...props }) => {
  const [isAccessoriesCollapse, setAccessoriesCollapse] = useState(false);
  const axisOptions = useSelector(selectAxisOptions);
  const bundleData = axisOptions?.selectedBundle?.bundleData;
  const accessories = bundleData?.accessories;

  return (
    accessories && (
      <div className="AccessoriesSection" {...props}>
        <div
          onClick={() => setAccessoriesCollapse(!isAccessoriesCollapse)}
          className="bg-[#A0A4A8] rounded-sm text-white h-7 px-2 font-semibold flex items-center space-x-2 cursor-pointer select-none"
        >
          {!isAccessoriesCollapse && <FiChevronDown />}
          {isAccessoriesCollapse && <FiChevronUp />}
          <span>{t("cartesian.ui.accessories")}</span>
        </div>
        {!isAccessoriesCollapse && (
          <div className="flex flex-col">
            <AccessoriesHeaderSection data-testid="accessories-header-section" />
            <AccessoriesDatasSection data-testid="accessories-data-section" />
          </div>
        )}
      </div>
    )
  );
};

const AdaptationKitsSection = ({ ...props }) => {
  const [isAdaptationKitCollapse, setAdaptationKitCollapse] = useState(false);
  const axisOptions = useSelector(selectAxisOptions);
  let adaptationKitWithinBundleQty = useSelector(selectAdaptationKitWithinBundleQty);
  const bundleData = axisOptions?.selectedBundle?.bundleData;
  const adaptationKitRef = bundleData?.adaptationKit?.commercialReference;
  const cartesianAdaptationKit = bundleData?.cartesianAdaptationKit;

  console.log(isAdaptationKitCollapse);

  if (adaptationKitWithinBundleQty === undefined) {
    const bom = useSelector(selectBillOfMaterials);
    adaptationKitWithinBundleQty = getAdaptationKitWithinBundleQty(bom);
  }

  let adaptationKitToBundleQty = useSelector(selectAdaptationKitToBundleQty);
  if (adaptationKitToBundleQty === undefined) {
    const bom = useSelector(selectBillOfMaterials);
    adaptationKitToBundleQty = getAdaptationKitToBundleQty(bom);
  }

  return (
    <div className="AdaptationKitsSection" {...props}>
      {(cartesianAdaptationKit || adaptationKitRef) && (
        <div
          onClick={() => setAdaptationKitCollapse(!isAdaptationKitCollapse)}
          className="bg-[#A0A4A8] rounded-sm text-white h-7 px-2 font-semibold flex items-center space-x-2 cursor-pointer select-none"
        >
          {!isAdaptationKitCollapse && <FiChevronDown />}
          {isAdaptationKitCollapse && <FiChevronUp />}
          <span>{t("cartesian.ui.finalize.adaptation_kits")}</span>
        </div>
      )}

      {!isAdaptationKitCollapse && (
        <div className="flex flex-col">
          <AccessoriesHeaderSection data-testid="adaptation-kits-header-section" />
          {adaptationKitRef && (
            <div className="AccessoriesDatasSection flex flex-row p-[0.25rem]" {...props}>
              <div className="finalizecartesian-values-blue underline w-[25%]">{adaptationKitRef}</div>
              <div className="finalizecartesian-summary w-[65%]">Adaptation kit within bundle</div>
              <div className="finalizecartesian-summary w-[10%] flex justify-center">
                {adaptationKitWithinBundleQty}
              </div>
            </div>
          )}
          {cartesianAdaptationKit && (
            <div className="AccessoriesDatasSection flex flex-row p-[0.25rem]" {...props}>
              <div className="finalizecartesian-values-blue underline w-[25%]">{cartesianAdaptationKit}</div>
              <div className="finalizecartesian-summary w-[65%]">Adaptation kit Axis to bundle</div>
              <div className="finalizecartesian-summary w-[10%] flex justify-center">{adaptationKitToBundleQty}</div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const FinalizeCartesian = ({ ...props }) => {
  const dispatch = useDispatch();
  const steps = useSelector(selectCartesianSteps);

  const axisOptions = useSelector(selectAxisOptions);
  const gearbox = axisOptions?.selectedBundle?.bundleData?.gearbox;
  const motor = axisOptions?.selectedBundle?.bundleData?.motor;
  const adaptaionKit = axisOptions?.selectedBundle?.bundleData?.adaptationKit;

  const driveAddedToBOM = axisOptions?.mountingOptions?.drive?.addedToBOM;
  const drive = axisOptions?.selectedBundle?.bundleData?.drive;

  const referenceIds = [];
  if (gearbox) {
    referenceIds.push(gearbox.commercialReference);
  }
  if (motor) {
    referenceIds.push(motor.commercialReference);
  }
  if (driveAddedToBOM && drive) {
    referenceIds.push(drive.commercialReference);
  }
  if (adaptaionKit) {
    referenceIds.push(adaptaionKit.commercialReference);
  }

  const handlePrevious = () => {
    dispatch(setCartesianCurrentStep(steps.AXIS_OPTIONS));
    dispatch(updateConfiguration());
  };

  return (
    <div className="FinalizeCartesian flex" {...props}>
      <div className="w-[60%] flex flex-col finalizecartesian-page-split-part with-margin space-y-4">
        <LinearAxis data-testid="linear-axis" />
        <DriveSection data-testid="drive-section" />
        <AdaptationKitsSection data-testid="adaptation-kits-section" />
        <AccessoriesSection data-testid="accessories-section" />
      </div>
      <div className="w-[40%] finalizecartesian-page-split-part flex flex-col space-y-4 border-l px-1">
        <ConfigurationSaved data-testid="configuration-saved" />
        <div className="flex flex-col gap-4">
          <ActionSharing data-testid="action-sharing" />
          <ActionLinks data-testid="action-links" />
          <Documentation referenceIds={referenceIds} data-testid="documentation" />
        </div>
      </div>
      <Navigator
        data-testid="navigator"
        continueLabel={t("msizer.ui.footer.go_to_start_page")}
        continueAction={() => {
          dispatch(resetCartesian());
          dispatch(setFullScreen(false));
        }}
        continueButtonStandard="true"
        previousAction={() => {
          handlePrevious();
        }}
      />
    </div>
  );
};

export default FinalizeCartesian;
